"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DDStateMessage = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../../../shared/core");
var copy_1 = require("../../../../copy");
function DDStateMessage(_a) {
    var recommendedDirectDebit = _a.recommendedDirectDebit;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    var statusList = (recommendedDirectDebit && recommendedDirectDebit.state) || [];
    if (statusList.includes('AccountInLoss')) {
        return react_1.default.createElement(Copy, { copyKey: "changeDirectDebitStateAccountInLoss" });
    }
    if (statusList.includes('BillingOnHold') ||
        statusList.includes('AmountOverSensibleUpperLimit') ||
        !recommendedDirectDebit ||
        recommendedDirectDebit.friendlyAmount === null) {
        return react_1.default.createElement(Copy, { copyKey: "changeDirectDebitStateNoRecommendations" });
    }
    if (statusList.includes('RecentlyOnboarded')) {
        return react_1.default.createElement(Copy, { copyKey: "changeDirectDebitStateRecentlyOnboarded" });
    }
    return null;
}
exports.DDStateMessage = DDStateMessage;
